import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { log } from '@/utils/core/vueLogger.js';
import { CacheManager } from '@/utils/core/cacheManager.js';

// home.js loadReleaseNotes(): a versioned static asset (not an authenticated API endpoint), fetched
// at most once every 5 hours, with an offline/error fallback to the last cached copy - reimplemented
// independently of externis.releaseNotes()/storage 'RELEASENOTES', which the legacy keeps writing on
// its own regardless of whether Vue also reads this file.
const releaseNotesCache = new CacheManager('VueCache', 'cache', {
	maxAge: 5 * 60 * 60 * 1000,
	memoryCacheTTL: 5 * 60 * 60 * 1000,
	logCategory: 'ReleaseNotes',
	keyPrefix: () => `${iframeDataBridge.getCustomer() ?? 'unknown'}.releaseNotes.`,
});

export async function getReleaseNotes(forceRefresh = false) {
	return releaseNotesCache.fetchOrCache('all', fetchReleaseNotesFromFile, { forceRefresh, fallback: [], backgroundRefresh: true });
}

async function fetchReleaseNotesFromFile() {
	const response = await fetch(`/m.eagle/release-note.json?foo=${Date.now()}`);
	if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

	const notes = await response.json();
	log('success', 'ReleaseNotes', `✅ Fetched ${notes.length} release notes`);
	return notes;
}
